<template>
  <div class="total-rank"  ref="section01">
    <p class="total-rank__label">総合ランク 
      <span class="icon-help" data-tooltip='労務監査、人的資本管理への対応状況をもとに算出しています。<br>詳しくは<a href="https://support.roumu-kansa.jp/faq/about/2680149.html" target="_blank">サポートサイト</a>をご確認ください。'><img src="@/assets/img/common/icon-help.svg" alt="" width="16px"></span></p>
    <div class="total-rank-ranking">
      <div class="total-rank-ranking__img">
        <img v-show="rankString=='AAA'" src="@/assets/img/common/medal01.svg" alt="">
        <img v-show="rankString=='AA'" src="@/assets/img/common/medal02.svg" alt="">
        <img v-show="rankString=='A'" src="@/assets/img/common/medal03.svg" alt="">
        <div class="total-rank-ranking__flash"></div>
      </div>
      <p class="total-rank-ranking__text">{{rankString}}</p>
    </div>
    <div class="total-rank-ranking-scale">
      <ul class="total-rank-ranking-scale__bar">
        <li v-bind:class="{'is-current': this.level0 == true}" ></li>
        <li v-bind:class="{'is-current': this.level1 == true}" ></li>
        <li v-bind:class="{'is-current': this.level2 == true}" ></li>
        <li v-bind:class="{'is-current': this.level3 == true}" ></li>
        <li v-bind:class="{'is-current': this.level4 == true}" ></li>
        <li v-bind:class="{'is-current': this.level5 == true}" ></li>
        <li v-bind:class="{'is-current': this.level6 == true}" ></li>
        <li v-bind:class="{'is-current': this.level7 == true}" ></li>
        <li v-bind:class="{'is-current': this.level8 == true}" ></li>
        </ul>
        <ul class="total-rank-ranking-scale__label">
          <li>AAA</li>
          <li>AA</li>
          <li>A</li>
          <li>BBB</li>
          <li>BB</li>
          <li>B</li>
          <li>CCC</li>
          <li>CC</li>
          <li>C</li>
        </ul>
      </div>
    </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    corpId: {},
    diagResultId: {},
  },
  data() {
    return {
      rankString: '---',
      level0: false,
      level1: false,
      level2: false,
      level3: false,
      level4: false,
      level5: false,
      level6: false,
      level7: false,
      level8: false,
    }
  },
  created: function() {
    this.initValue();
//    this.changeCorpId(this.corpId, this.diagResultId);
  },
  methods: {
    initValue() {
        this.rankString = '---';
        this.level0 = this.level1 = this.level2 = this.level3 = this.level4 = this.level5 = this.level6 = this.level7 = this.level8 = false; 
    },
    async changeCorpId(corpId, diagResultId) {
      let res = await this.$axios.post('/ld/api/hr/getCorporateRank', {
        corpId: corpId,
        diagResultId: diagResultId,
      });
      if (res.status == 200) {
        this.rankString = res.data.rankString;
        this.level0 = res.data.levelArr['AAA'];
        this.level1 = res.data.levelArr['AA'];
        this.level2 = res.data.levelArr['A'];
        this.level3 = res.data.levelArr['BBB'];
        this.level4 = res.data.levelArr['BB'];
        this.level5 = res.data.levelArr['B'];
        this.level6 = res.data.levelArr['CCC'];
        this.level7 = res.data.levelArr['CC'];
        this.level8 = res.data.levelArr['C'];
      }else {
        this.rankString = '---';
        this.level0 = this.level1 = this.level2 = this.level3 = this.level4 = this.level5 = this.level6 = this.level7 = this.level8 = false; 
      }
    }
  },
}
</script>

<style scoped>
.chart-area {
  border: 2px solid rgba(220, 220, 220, 0.5);
  border-radius: 10px;
  padding: 10px;
  background-color: rgba(248, 248, 255, 0.5);
}
</style>